import { useControlViewersStore } from "../states/control-viewers";

import { useTeamState } from "@/modules/team/states";
import { useLoggedInMember } from "@/modules/auth/states";
import { getAgentData } from "../states";
import { AGENT_TYPES } from "../types";

export const useControlEditStatus = (agentId: string, id: string) => {
	const loggedInMember = useLoggedInMember();
	const { editorsMap } = useControlViewersStore();
	const { team } = useTeamState();

	// get the agent data to determine the type
	const agentData = getAgentData(agentId);
	
	let originalId: string;
	
	// For policy management, use the controlId directly
	if (agentData?.agentType === AGENT_TYPES.POLICY_MANAGEMENT) {
		originalId = id; // For policy management, the id passed is already the controlId
	} else {
		// For review responses, get the original id from reviewResponseData
		const control = agentData?.mainData.reviewResponseData
			?.get(id)
			?.find((field) => field.key === "id" );
		originalId = control?.value as string;
	}

	// Use originalId for checking edit status
	const editorId = editorsMap.get(agentId)?.get(originalId);
	const isBeingEdited = !!editorId && editorId !== loggedInMember?.member_id;

	const editor = team.find((member) => member.member_id === editorId);
	const editorName = editor?.name || "Unknown User";

	return {
		isBeingEdited,
		editorId,
		editorName,
	};
};
